import { Document, Page, View } from "@react-pdf/renderer";
import DriverSchedule from "./components/DriverSchedule";
import FinanceDetails from "./components/FinanceDetails";
import InsuredInfo from "./components/InsuredInfo";
import TrailerSchedule from "./components/TrailerSchedule";
import VehicleSchedule from "./components/VehicleSchedule";
import Header from "./components/header";

function QuotePDF({
  companyData,
  quoteData,
  coveragesData,
  financeDetailsData,
  vehiclesData,
  trailersData,
  driversData,
}) {
  return (
    <Document title="Commercial Trucking Application & Quote">
      <Page size="A4">
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "100vh",
            color: "black",
          }}
        >
          <Header companyData={companyData} />
          <InsuredInfo quoteData={quoteData} />
          <FinanceDetails
            financeDetailsData={financeDetailsData}
            coveragesData={coveragesData}
          />
        </View>
      </Page>

      <Page size="A4">
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "100vh",
            color: "black",
          }}
        >
          <VehicleSchedule vehiclesData={vehiclesData} />
          <TrailerSchedule trailersData={trailersData} />
          <DriverSchedule driversData={driversData} />
        </View>
      </Page>
    </Document>
  );
}
export default QuotePDF;
